var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHollowSquareSpace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 55,
    fill: "none",
    viewBox: "0 0 57 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M15.788 43.68h25.174a4 4 0 0 0 4-4V14.505a4 4 0 0 0-4-4H15.788a4 4 0 0 0-4 4V39.68a4 4 0 0 0 4 4Zm6.758-6.758h11.659a4 4 0 0 0 4-4V21.263a4 4 0 0 0-4-4h-11.66a4 4 0 0 0-4 4v11.66a4 4 0 0 0 4 4Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 16.587,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.15,
    cy: 16.587,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.351,
    cy: 51.096,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 17.35 51.096)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.351,
    cy: 4.098,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 17.35 4.098)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 27.645,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.15,
    cy: 27.645,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.374,
    cy: 51.004,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 28.374 51.004)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.374,
    cy: 4.006,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 28.374 4.006)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 38.704,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.15,
    cy: 38.704,
    r: 3.87,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.432,
    cy: 50.902,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 39.432 50.902)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.432,
    cy: 3.904,
    r: 3.87,
    fill: "#D9D9D9",
    transform: "rotate(-90.503 39.432 3.904)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHollowSquareSpace);
export default __webpack_public_path__ + "static/media/hollow-square-space.16a2ffb106ecb9ba46e73aab866a4962.svg";
export { ForwardRef as ReactComponent };